export function convertFileTypeToMimeType(typeFile: string | null): string {
    let fileTypeToMimeType = {
       'aac': 'audio/aac',
       'abw': 'application/x-abiword',
       'arc': 'application/x-freearc',
       'avif': 'image/avif',
       'avi': 'video/x-msvideo',
       'azw': 'application/vnd.amazon.ebook',
       'bin': 'application/octet-stream',
       'bmp': 'image/bmp',
       'bz': 'application/x-bzip',
       'bz2': 'application/x-bzip2',
       'cda': 'application/x-cdf',
       'csh': 'application/x-csh',
       'css': 'text/css',
       'csv': 'text/csv',
       'doc': 'application/msword',
       'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
       'eot': 'application/vnd.ms-fontobject',
       'epub': 'application/epub+zip',
       'gz': 'application/gzip',
       'gif': 'image/gif',
       'htm': 'text/html',
       'html': 'text/html',
       'ico': 'image/vnd.microsoft.icon',
       'ics': 'text/calendar',
       'jar': 'application/java-archive',
       'jpeg': 'image/jpeg',
       'jpg': 'image/jpeg',
       'js': 'text/javascript',
       'json': 'application/json',
       'jsonld': 'application/ld+json',
       'mid': 'audio/midi',
       'midi': 'audio/x-midi',
       'mjs': 'text/javascript',
       'mp3': 'audio/mpeg',
       'mp4': 'video/mp4',
       'mpeg': 'video/mpeg',
       'mpkg': 'application/vnd.apple.installer+xml',
       'odp': 'application/vnd.oasis.opendocument.presentation',
       'ods': 'application/vnd.oasis.opendocument.spreadsheet',
       'odt': 'application/vnd.oasis.opendocument.text',
       'oga': 'audio/ogg',
       'ogv': 'video/ogg',
       'ogx': 'application/ogg',
       'opus': 'audio/opus',
       'otf': 'font/otf',
       'png': 'image/png',
       'pdf': 'application/pdf',
       'php': 'application/x-httpd-php',
       'ppt': 'application/vnd.ms-powerpoint',
       'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
       'rar': 'application/vnd.rar',
       'rtf': 'application/rtf',
       'sh': 'application/x-sh',
       'svg': 'image/svg+xml',
       'swf': 'application/x-shockwave-flash',
       'tar': 'application/x-tar',
       'tif': 'image/tiff',
       'tiff': 'image/tiff',
       'ts': 'video/mp2t',
       'ttf': 'font/ttf',
       'txt': 'text/plain',
       'vsd': 'application/vnd.visio',
       'wav': 'audio/wav',
       'weba': 'audio/webm',
       'webm': 'video/webm',
       'webp': 'image/webp',
       'woff': 'font/woff',
       'woff2': 'font/woff2',
       'xhtml': 'application/xhtml+xml',
       'xls': 'application/vnd.ms-excel',
       'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
       'xml': 'application/xml',
       'xul': 'application/vnd.mozilla.xul+xml',
       'zip': 'application/zip',
       '3gp': 'video/3gpp',
       '3g2': 'video/3gpp2',
       '7z': 'application/x-7z-compressed'
    } as const;
    if (fileTypeToMimeType.hasOwnProperty(typeFile)) {
       return fileTypeToMimeType[typeFile];
    }
    // ในกรณีไม่เจอ type เลย จะตั้ง default เป็น PDF
    return 'application/pdf';
 }

export function convertMimeTypeToFileType(mimeFile: string | null): string {
    let mimeFileToTypeFile = {
       'audio/aac': 'aac',
       'application/x-abiword': 'abw',
       'application/x-freearc': 'arc',
       'image/avif': 'avif',
       'video/x-msvideo': 'avi',
       'application/vnd.amazon.ebook': 'azw',
       'application/octet-stream': 'bin',
       'image/bmp': 'bmp',
       'application/x-bzip': 'bz',
       'application/x-bzip2': 'bz2',
       'application/x-cdf': 'cda',
       'application/x-csh': 'csh',
       'text/css': 'css',
       'text/csv': 'csv',
       'application/msword': 'doc',
       'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
       'application/vnd.ms-fontobject': 'eot',
       'application/epub+zip': 'epub',
       'application/gzip': 'gz',
       'image/gif': 'gif',
       'text/htm': 'htm',
       'html': 'html',
       'image/vnd.microsoft.icon': 'ico',
       'text/calendar': 'ics',
       'application/java-archive': 'jar',
       'image/jpeg': 'jpeg',
       'image/jpg': 'jpg',
       'text/javascript': 'js',
       'application/json': 'json',
       'application/ld+json': 'jsonld',
       'audio/mid': 'midi',
       'audio/x-midi': 'midi',
       // 'text/javascript' : 'mjs',
       'audio/mpeg': 'mp3',
       'video/mp4': 'mp4',
       'video/mpeg': 'mpeg',
       'application/vnd.apple.installer+xml': 'mpkg',
       'application/vnd.oasis.opendocument.presentation': 'odp',
       'application/vnd.oasis.opendocument.spreadsheet': 'ods',
       'application/vnd.oasis.opendocument.text': 'odt',
       'audio/ogg': 'oga',
       'video/ogg': 'ogv',
       'application/ogg': 'ogx',
       'audio/opus': 'opus',
       'font/otf': 'otf',
       'image/png': 'png',
       'application/pdf': 'pdf',
       'application/x-httpd-php': 'php',
       'application/vnd.ms-powerpoint': 'ppt',
       'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
       'application/vnd.rar': 'rar',
       'application/rtf': 'rtf',
       'application/x-sh': 'sh',
       'image/svg+xml': 'svg',
       'application/x-shockwave-flash': 'swf',
       'application/x-tar': 'tar',
       'image/tiff': 'tiff',
       'image/tif' : 'tif',
       'video/mp2t': 'ts',
       'font/ttf': 'ttf',
       'text/plain': 'txt',
       'application/vnd.visio': 'vsd',
       'audio/wav': 'wav',
       'audio/webm': 'weba',
       'video/webm': 'webm',
       'image/webp': 'webp',
       'font/woff': 'woff',
       'font/woff2': 'woff2',
       'application/xhtml+xml': 'xhtml',
       'application/vnd.ms-excel': 'xls',
       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
       'application/xml': 'xml',
       'application/vnd.mozilla.xul+xml': 'xul',
       'application/zip': 'zip',
       'video/3gpp': '3gp',
       'video/3gpp2': '3g2',
       'application/x-7z-compressed': '7z'
    } as const;
    if (mimeFileToTypeFile.hasOwnProperty(mimeFile)) {
       return mimeFileToTypeFile[mimeFile];
    }
    // ในกรณีไม่เจอ type เลย จะตั้ง default เป็น PDF
    return 'pdf';
 }